module.exports = __webpack_public_path__ + "static/media/banner-helper.ec68b32f.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/banner-helper.png
// module id = 2141
// module chunks = 0